export default __webpack_public_path__ + "static/main-logo-white-ac564d7fca43b7e3232f93e1640398a3.svg";